import React from 'react';
import { connect } from 'react-redux';


class NoResultImportantInfo extends React.Component {

    // FIXME Styles/layout
    render() {

        return (
            <div>
                <div style={{color: '#ec7c33', fontWeight: 'bold'}}>{this.props.strings.IMPORTANT_NO_RESULTS_MESSAGE_1}</div><br/>
                <p>{this.props.strings.IMPORTANT_NO_RESULTS_MESSAGE_3}<b>{this.props.strings.IMPORTANT_NO_RESULTS_MESSAGE_4}</b>{this.props.strings.IMPORTANT_NO_RESULTS_MESSAGE_5}</p>
                <p>
                    {this.props.strings.IMPORTANT_NO_RESULTS_MESSAGE_6}
                    <b><a href={this.props.strings.COVID_MAIN_PAGE_LINK}>{this.props.strings.IMPORTANT_NO_RESULTS_MESSAGE_7}</a></b>
                    {this.props.strings.IMPORTANT_NO_RESULTS_MESSAGE_8}
                </p>
                <div>
                    <p>
                        {this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1A}
                        <strong>
                            <a href={this.props.strings.TREATMENT_LINK}>{this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1B}</a>
                        </strong>
                        {this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1C}
                    </p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        language: state.language.language,
    }
}

const ConnectedNoResultImportantInfo = connect(
    mapStateToProps
)(NoResultImportantInfo);
export default ConnectedNoResultImportantInfo;
